export type MaterialType = 'wall' | 'floor' | 'uni' | 'facade';

export type FilterType = 'wall' | 'floor' | 'all' | 'uni';

export const mapFilterTypeToMaterialTypes = (type: FilterType) => {
  return {
    uni: ['uni'],
    floor: ['floor'],
    wall: ['wall'],
    all: ['uni', 'floor', 'wall'],
  }[type] as MaterialType[];
};

export const mapTypeToUses = (type: MaterialType) => {
  return { uni: '5', floor: '7', wall: '8', facade: '48' }[type];
};

export const mapUsesToType = (uses: string): MaterialType[] => {
  return uses
    .split(',')
    .filter((use) => ['5', '7', '8', '48'].includes(use))
    .map((use) => {
      return { '5': 'uni', '7': 'floor', '8': 'wall', '48': 'facade' }[
        use
      ] as MaterialType;
    });
};
